import GButton from "./";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsEye from "../icons/eye";

const isNotCompact = (display) => display !== "compact";

<template>
  <GButton
    @type={{@type}}
    @color="outline"
    @disabled={{@disabled}}
    @loading={{@loading}}
    @display={{if @display @display "default"}}
    {{mergeClasses}}
    ...attributes
  >
    <div class="flex items-center">
      <IconsEye class="w-5 mr-1 {{if (isNotCompact @display) '-ml-1.5'}} -mt-px text-rebeccapurple-700" />
      <span>{{yield}}</span>
    </div>
  </GButton>
</template>
